// AB#333570 - validadores puros de documento (CPF/CNPJ)
import { isValid as isValidCnpjCore, normalize as normalizeCnpj } from './CnpjUtils';
/**
 * Normaliza CPF removendo caracteres não-dígitos.
 * AB#333573 - RN14 (inverso — para CPF, strip-to-digits é semântico).
 */
export function normalizeCpf(value) {
    if (!value)
        return '';
    return value.replace(/\D/g, '');
}
export function isValidCpf(value) {
    var digits = normalizeCpf(value);
    if (digits.length !== 11)
        return false;
    if (/^(\d)\1+$/.test(digits))
        return false;
    var soma = 0;
    for (var i = 1; i <= 9; i++)
        soma += parseInt(digits.substring(i - 1, i), 10) * (11 - i);
    var resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    if (resto !== parseInt(digits.substring(9, 10), 10))
        return false;
    soma = 0;
    for (var i = 1; i <= 10; i++)
        soma += parseInt(digits.substring(i - 1, i), 10) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    return resto === parseInt(digits.substring(10, 11), 10);
}
export function isValidCnpj(value) {
    return isValidCnpjCore(value);
}
export function detectTipo(value) {
    var normalized = normalizeCnpj(value);
    if (!normalized)
        return 'unknown';
    if (normalized.length === 11 && /^\d+$/.test(normalized))
        return 'cpf';
    if (normalized.length === 14)
        return 'cnpj';
    if (/[A-Z]/.test(normalized))
        return 'cnpj';
    return 'unknown';
}
export function isValidForTipo(value, tipo) {
    var detected = detectTipo(value);
    if (tipo === 'auto') {
        if (detected === 'cpf')
            return isValidCpf(value);
        if (detected === 'cnpj')
            return isValidCnpj(value);
        return false;
    }
    if (tipo !== detected)
        return false;
    return tipo === 'cpf' ? isValidCpf(value) : isValidCnpj(value);
}
export function inferTipoPessoa(value) {
    var normalized = normalizeCnpj(value);
    if (!normalized)
        return null;
    if (normalized.length === 11 && /^\d+$/.test(normalized))
        return 'PF';
    if (normalized.length === 14)
        return 'PJ';
    if (/[A-Z]/.test(normalized) && normalized.length >= 9)
        return 'PJ';
    return null;
}
